import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import type { SmartViewArtifactAgentMode } from "../../../../../api/types/smartViewArtifactsTypes";

interface ModeOption {
  mode: SmartViewArtifactAgentMode;
  description: string;
}

const modeOptions: ModeOption[] = [
  { mode: "Quick", description: "Faster, fine for small changes." },
  { mode: "Thorough", description: "Takes longer and is more careful: use it for new dashboards and bigger changes." },
];

interface Props {
  value: SmartViewArtifactAgentMode;
  disabled?: boolean;
  onChange: (mode: SmartViewArtifactAgentMode) => void;
}

const ArtifactAgentModePicker = ({ value, disabled, onChange }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleSelect = (mode: SmartViewArtifactAgentMode) => {
    onChange(mode);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        color="secondary"
        disabled={disabled}
        endIcon={<ExpandMoreRoundedIcon />}
        aria-label={`Mode: ${value}`}
        aria-haspopup="menu"
        aria-expanded={anchorEl !== null}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {value}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={anchorEl !== null}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        slotProps={{ paper: { sx: { width: 340 } } }}
      >
        {modeOptions.map(({ mode, description }) => (
          <MenuItem
            key={mode}
            role="menuitemradio"
            aria-checked={mode === value}
            onClick={() => handleSelect(mode)}
            sx={{ gap: 2 }}
          >
            <ListItemText
              primary={mode}
              secondary={description}
              slotProps={{
                primary: { variant: "subtitle2", component: "span" },
                secondary: { variant: "caption", sx: { display: "block", whiteSpace: "normal" } },
              }}
            />
            <ListItemIcon sx={{ minWidth: 0, visibility: mode === value ? "visible" : "hidden" }}>
              <CheckRoundedIcon color="primary" />
            </ListItemIcon>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ArtifactAgentModePicker;
